import { SxProps, Theme } from '@mui/material/styles';

/**
 * Common styling function for table cells
 * Provides consistent styling across all table components
 */
export const getCellStyle = (maxWidth?: string, minWidth?: string): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  wordWrap: 'break-word',
  whiteSpace: 'normal',
  lineHeight: 1.4,
  padding: '4px 0',
  maxWidth: maxWidth || '100%',
  minWidth: minWidth || '100%',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
});

/**
 * Default cell style without width constraints
 */
export const getDefaultCellStyle = (): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minWidth: 0,
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
});
